"use client";

import { useState } from "react";
import styles from "./page.module.css";

export default function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  const [status, setStatus] = useState<"idle" | "sending" | "success" | "error">("idle");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus("sending");

    // Simulación de envío (aquí podrías integrar con un servicio de email)
    setTimeout(() => {
      setStatus("success");
      setFormData({ name: "", email: "", subject: "", message: "" });
      setTimeout(() => setStatus("idle"), 3000);
    }, 1500);
  };

  return (
    <div className={styles.page}>
      {/* Hero Section */}
      <section className={styles.hero}>
        <div className="container">
          <h1 className={styles.heroTitle}>CONTACTO</h1>
        </div>
      </section>

      {/* Contact Content */}
      <section className="section">
        <div className="container">
          <div className={styles.content}>
            {/* Contact Info */}
            <div className={styles.infoSection}>
              <div className={styles.contactInfo}>
                <div className={styles.contactItem}>
                  <span className={styles.label}>e-mail:</span>
                  <a href="mailto:plataforma.fip.bank@gmail.com" className={styles.email}>
                    plataforma.fip.bank@gmail.com
                  </a>
                </div>

                <div className={styles.socialSection}>
                  <h3 className={styles.socialTitle}>Redes Sociales</h3>
                  
                  <div className={styles.socialGroup}>
                    <h4>Grupo Lab</h4>
                    <div className={styles.contactItem}>
                      <span className={styles.label}>e-mail:</span>
                      <a href="mailto:grupolab@ucm.es" className={styles.email}>
                        grupolab@ucm.es
                      </a>
                    </div>
                    <div className={styles.socialLinks}>
                      <a href="https://www.ucm.es/grupolab/conociendo-grupolab" target="_blank" rel="noopener noreferrer" className={styles.socialLink} title="Web">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <circle cx="12" cy="12" r="10"/>
                          <line x1="2" y1="12" x2="22" y2="12"/>
                          <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
                        </svg>
                      </a>
                      <a href="https://www.linkedin.com/in/grupolab-ucm-25a984186/" target="_blank" rel="noopener noreferrer" className={styles.socialLink} title="LinkedIn">
                        <svg viewBox="0 0 24 24" fill="currentColor">
                          <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                        </svg>
                      </a>
                      <a href="https://x.com/lab_grupo" target="_blank" rel="noopener noreferrer" className={styles.socialLink} title="X">
                        <svg viewBox="0 0 24 24" fill="currentColor">
                          <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                        </svg>
                      </a>
                    </div>
                  </div>

                  <div className={styles.socialGroup}>
                    <h4>ITC (Instituto de Tecnología del Conocimiento UCM)</h4>
                    <div className={styles.contactItem}>
                      <span className={styles.label}>e-mail:</span>
                      <a href="mailto:itc@ucm.es" className={styles.email}>
                        itc@ucm.es
                      </a>
                    </div>
                    <div className={styles.socialLinks}>
                      <a href="https://www.ucm.es/itc" target="_blank" rel="noopener noreferrer" className={styles.socialLink} title="Web">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <circle cx="12" cy="12" r="10"/>
                          <line x1="2" y1="12" x2="22" y2="12"/>
                          <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
                        </svg>
                      </a>
                      <a href="https://www.youtube.com/@itc-ucm" target="_blank" rel="noopener noreferrer" className={styles.socialLink} title="Youtube">
                        <svg viewBox="0 0 24 24" fill="currentColor">
                          <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                        </svg>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div className={styles.formSection}>
              <h2>Envíanos un Mensaje</h2>
              <form onSubmit={handleSubmit} className={styles.form}>
                <div className={styles.formGroup}>
                  <label htmlFor="name">Nombre *</label>
                  <input
                    type="text"
                    id="name"
                    value={formData.name}
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                    required
                    placeholder="Tu nombre completo"
                  />
                </div>

                <div className={styles.formGroup}>
                  <label htmlFor="email">Email *</label>
                  <input
                    type="email"
                    id="email"
                    value={formData.email}
                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                    required
                    placeholder="tu@email.com"
                  />
                </div>

                <div className={styles.formGroup}>
                  <label htmlFor="subject">Asunto *</label>
                  <select
                    id="subject"
                    value={formData.subject}
                    onChange={(e) => setFormData({ ...formData, subject: e.target.value })}
                    required
                  >
                    <option value="">Selecciona un asunto</option>
                    <option value="buena-practica">Compartir una buena práctica</option>
                    <option value="consulta">Consulta general</option>
                    <option value="sugerencia">Sugerencia</option>
                    <option value="colaboracion">Propuesta de colaboración</option>
                    <option value="otro">Otro</option>
                  </select>
                </div>

                <div className={styles.formGroup}>
                  <label htmlFor="message">Mensaje *</label>
                  <textarea
                    id="message"
                    value={formData.message}
                    onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                    required
                    rows={6}
                    placeholder="Cuéntanos en qué podemos ayudarte..."
                  />
                </div>

                {status === "success" && (
                  <div className={styles.successMessage}>
                    ✓ ¡Mensaje enviado con éxito! Te responderemos pronto.
                  </div>
                )}

                {status === "error" && (
                  <div className={styles.errorMessage}>
                    ✕ Hubo un error al enviar el mensaje. Por favor, intenta de nuevo.
                  </div>
                )}

                <button
                  type="submit"
                  disabled={status === "sending"}
                  className={styles.submitButton}
                >
                  {status === "sending" ? "Enviando..." : "Enviar Mensaje"}
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
